import React from 'react';
import './PersonalNoteCard.css';

/**
 * PersonalNoteCard - Display a single personal note
 * Now handles HTML content from RichTextEditor
 */
const PersonalNoteCard = ({ note, onEdit, onDelete, onManageAccess }) => {
  // Extract plain text from HTML for preview
  const getPlainTextPreview = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const plainText = temp.innerText || '';
    return plainText.substring(0, 150) + (plainText.length > 150 ? '...' : '');
  };
  const getTimeAgo = (date) => {
    if (!date) return 'Just now';

    const now = new Date();
    const noteDate = new Date(date);
    const diffMs = now - noteDate;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;

    return noteDate.toLocaleDateString();
  };

  const getCategoryEmoji = (category) => {
    const categoryMap = {
      reflection: '💭',
      analysis: '📊',
      progress: '📈',
      personal: '📝'
    };
    return categoryMap[category] || '📝';
  };

  const getAccessBadgeText = () => {
    if (note.isPrivate) {
      return '🔒 Private';
    }
    return `🔓 Shared with ${note.sharedCount} coach${note.sharedCount !== 1 ? 'es' : ''}`;
  };

  return (
    <div className="personal-note-card">
      {/* Note content area (read-only) */}
      <div
        className="card-clickable-area"
      >
        <div className="card-header">
          <div className="card-title-section">
            {note.title && <h4>{note.title}</h4>}
            {note.category && (
              <span className="category-badge">
                {getCategoryEmoji(note.category)} {note.category}
              </span>
            )}
          </div>
        </div>

        <div className="card-content">
          <p className="note-preview">
            {getPlainTextPreview(note.content)}
          </p>
        </div>
      </div>

      {/* Non-clickable actions area */}
      <div className="card-actions-section">
        <div className="card-actions">
          <button className="btn-icon" onClick={onEdit} title="Edit note">
            ✏️
          </button>
          <button className="btn-icon danger" onClick={onDelete} title="Delete note">
            🗑️
          </button>
        </div>
      </div>

      <div className="card-footer">
        <button
          className={`access-badge access-badge-btn ${note.isPrivate ? 'private' : 'shared'}`}
          onClick={onManageAccess}
          title="Click to view and manage access"
        >
          {getAccessBadgeText()}
        </button>
      </div>

      <div className="card-meta">
        <span className="timestamp">
          Last updated: {getTimeAgo(note.updatedAt || note.createdAt)}
        </span>
      </div>
    </div>
  );
};

export default PersonalNoteCard;
